export const ar = {
  // Header
  subtitle: "حلول عقارية، نتائج ملموسة",
  
  // Navigation
  dashboard: "لوحة التحكم",
  clients: "العملاء",
  leads: "الفرص",
  importContacts: "استيراد من الهاتف",
  account: "الحساب",
  
  // Clients
  addClient: "إضافة عميل",
  searchClients: "ابحث عن عملاء",
  searchClientsPlaceholder: "ابحث بالاسم أو الهاتف أو الإيميل",
  noClients: "لم يتم العثور على عملاء",
  noClientsDesc: "ابدأ بإضافة أول عميل أو استيراد جهات الاتصال من هاتفك.",
  loadingClients: "جاري تحميل العملاء...",
  edit: "تعديل",
  delete: "حذف",
  selectAll: "تحديد الكل",
  selected: "محدد",
  deleteSelected: "حذف المحدد",
  areYouSureDelete: "هل أنت متأكد من حذف هذا العميل؟",
  areYouSureDeleteMultiple: "هل أنت متأكد من حذف",
  clientsText: "عميل؟",
  
  // Leads
  addLead: "إضافة فرصة",
  searchLeads: "ابحث عن فرص",
  searchLeadsPlaceholder: "ابحث بالاسم أو الهاتف أو الإيميل",
  noLeads: "لم يتم العثور على فرص",
  noLeadsDesc: "ابدأ بإضافة أول فرصة أو استيراد جهات الاتصال من هاتفك.",
  loadingLeads: "جاري تحميل الفرص...",
  convertToClient: "تحويل إلى عميل",
  convertConfirm: "تحويل هذه الفرصة إلى عميل؟",
  allStatus: "جميع الحالات",
  new: "جديد",
  contacted: "تم الاتصال",
  qualified: "مؤهل",
  converted: "تم التحويل",
  
  // Modals
  addNewClient: "إضافة عميل جديد",
  editClient: "تعديل العميل",
  addNewLead: "إضافة فرصة جديدة",
  editLead: "تعديل الفرصة",
  name: "الاسم",
  nameRequired: "الاسم مطلوب",
  phone: "الهاتف",
  whatsapp: "واتساب",
  email: "البريد الإلكتروني",
  address: "العنوان",
  notes: "ملاحظات",
  status: "الحالة",
  active: "نشط",
  inactive: "غير نشط",
  source: "المصدر",
  interestType: "نوع الاهتمام",
  propertyPreference: "تفضيل العقار",
  budget: "الميزانية",
  cancel: "إلغاء",
  save: "حفظ",
  saving: "جاري الحفظ...",
  
  // Import
  importTitle: "استيراد جهات الاتصال",
  howToImport: "كيفية استيراد جهات الاتصال",
  fromiPhone: "من جهات اتصال iPhone",
  fromAndroid: "من Android/هواتف أخرى",
  supportedFormats: "الصيغ المدعومة",
  importAs: "استيراد كـ",
  dropFile: "اسحب ملف CSV هنا أو انقر للتصفح",
  supportedFormatsDesc: "الصيغ المدعومة: ملفات CSV أو vCard (.vcf)",
  preview: "معاينة (أول 10 صفوف)",
  totalRows: "سيتم استيراد إجمالي الصفوف في الملف. تأكد من أن المعاينة تبدو صحيحة.",
  importButton: "استيراد",
  importing: "جاري الاستيراد...",
  importAsClients: "استيراد كعملاء",
  importAsLeads: "استيراد كفرص",
  
  // Table view
  cards: "البطاقات",
  table: "الجدول",
  actions: "الإجراءات",
  
  // Status
  newStatus: "جديد",
  contactedStatus: "تم الاتصال",
  qualifiedStatus: "مؤهل",
  
  // Interest types
  buying: "شراء",
  selling: "بيع",
  renting: "إيجار",
  investing: "استثمار",
  
  // Messages
  selectAtLeastOne: "الرجاء تحديد عميل واحد على الأقل للحذف",
  selectAtLeastOneLead: "الرجاء تحديد فرصة واحدة على الأقل للحذف",
  failedToLoad: "فشل تحميل العملاء. يرجى المحاولة مرة أخرى.",
  failedToLoadLeads: "فشل تحميل الفرص. يرجى المحاولة مرة أخرى.",
  failedToDelete: "فشل حذف العميل. يرجى المحاولة مرة أخرى.",
  failedToDeleteLead: "فشل حذف الفرصة. يرجى المحاولة مرة أخرى.",
  failedToSave: "فشل حفظ العميل. يرجاء المحاولة مرة أخرى.",
  failedToSaveLead: "فشل حفظ الفرصة. يرجاء المحاولة مرة أخرى.",
  leadConverted: "تم تحويل الفرصة إلى عميل بنجاح!",
  successfullyDeleted: "تم الحذف بنجاح",
  successfullyImported: "تم الاستيراد بنجاح!",
  importCompletedWithErrors: "اكتمل الاستيراد مع وجود أخطاء",
  successfullyImportedCount: "تم استيراد",
  contacts: "جهة اتصال بنجاح",
  errors: "أخطاء",
  
  // Connection status
  serverConnectionError: "خطأ في اتصال الخادم",
  cannotConnect: "لا يمكن الاتصال بخادم الواجهة الخلفية. يرجى التأكد من تشغيل الخادم.",
  toStartServer: "لبدء الخادم:",
  runCommand: "افتح terminal وقم بتشغيل: cd server && npm run dev",
  
  // Language
  language: "اللغة",
  arabic: "العربية",
  english: "الإنجليزية",

  // Account
  accountInfo: "معلومات الحساب",
  userId: "معرّف المستخدم",
  roleLabel: "الدور",
  phoneLabel: "رقم الهاتف",
  createdAt: "تاريخ الإنشاء",
  ownerId: "معرّف المالك",
  refresh: "تحديث",
  loadingAccount: "جاري تحميل معلومات الحساب...",
  noUser: "لا توجد بيانات حساب",
  notAvailable: "غير متوفر",
  failedToLoadAccount: "فشل تحميل معلومات الحساب. حاول مرة أخرى.",
  failedToSaveAccount: "فشل حفظ معلومات الحساب.",
  accountUpdated: "تم تحديث الحساب بنجاح",
  back: "رجوع",
  
  // Import alerts
  pleaseSelectFile: "الرجاء تحديد ملف أولاً",
  pleaseSelectCSV: "الرجاء تحديد ملف CSV أو vCard (.vcf)",
  noValidContactsVCF: "لم يتم العثور على جهات اتصال صالحة في ملف vCard. تأكد من أن الملف يحتوي على معلومات الاتصال.",
  failedToImport: "فشل استيراد جهات الاتصال",
  errorReadingFile: "خطأ في قراءة الملف",
  
  // Contact actions
  call: "اتصل",
  noPhoneNumber: "لا يوجد رقم هاتف",
  noWhatsApp: "لا يوجد واتساب",
  noEmail: "لا يوجد بريد إلكتروني",
  
  // Activities
  activityHistory: "سجل الأنشطة",
  activities: "الأنشطة",
  addActivity: "إضافة نشاط",
  activityType: "نوع النشاط",
  noActivities: "لا توجد أنشطة مسجلة",
  meeting: "اجتماع",
  note: "ملاحظة",
  title: "العنوان",
  titlePlaceholder: "عنوان النشاط (اختياري)",
  description: "الوصف",
  descriptionPlaceholder: "وصف النشاط...",
  loading: "جاري التحميل...",
  
  // Reminders
  reminders: "التذكيرات",
  upcomingReminders: "التذكيرات القادمة",
  addReminder: "إضافة تذكير",
  reminderTitle: "عنوان التذكير",
  reminderTitlePlaceholder: "مثال: متابعة مع العميل",
  reminderDate: "تاريخ التذكير",
  noReminders: "لا توجد تذكيرات",
  deleteReminderConfirm: "هل أنت متأكد من حذف هذا التذكير؟",
  
  // Quick Actions
  quickActions: "إجراءات سريعة",
  viewClient: "عرض العميل",
  viewActivities: "عرض الأنشطة",
  viewReminders: "عرض التذكيرات",
  
  // Dashboard
  totalClients: "إجمالي العملاء",
  totalLeads: "إجمالي الفرص",
  recentActivities: "الأنشطة الأخيرة (7 أيام)",
  leadsByStatus: "الفرص حسب الحالة",
  clickForDetails: "انقر للتفاصيل",
  activitiesInfo: "لعرض الأنشطة، انقر على جهات الاتصال الفردية في قسم العملاء أو الفرص.",
  summary: "ملخص",
  recentActivitiesSummary: "عرض آخر {count} نشاط عبر جميع جهات الاتصال.",
  unknownContact: "جهة اتصال غير معروفة",
  
  // Export
  export: "تصدير",
  exportClients: "تصدير العملاء",
  exportLeads: "تصدير الفرص",
  
  // Favorites
  favorites: "المفضلة",
  showFavorites: "عرض المفضلة",
  showAll: "عرض الكل",
  addToFavorites: "إضافة إلى المفضلة",
  removeFromFavorites: "إزالة من المفضلة",
  
  // Deals
  deals: "الصفقات",
  viewDeals: "عرض الصفقات",
  addDeal: "صفقة جديدة",
  editDeal: "تعديل الصفقة",
  closedDeals: "الصفقات المكتملة",
  noDeals: "لا توجد صفقات مسجلة",
  noDealsDesc: "انقر على \"إضافة صفقة\" لإنشاء أول صفقة",
  deleteDealConfirm: "هل أنت متأكد من حذف هذه الصفقة؟",
  allDealTypes: "جميع الأنواع",
  allPropertyTypes: "جميع العقارات",
  contactType: "نوع جهة الاتصال",
  selectContact: "اختر جهة الاتصال",
  dealDetails: "تفاصيل الصفقة",
  failedToLoadDeals: "فشل تحميل الصفقات",
  propertyType: "نوع العقار",
  propertyAddress: "عنوان العقار",
  propertyAddressPlaceholder: "أدخل عنوان العقار",
  dealType: "نوع الصفقة",
  dealDate: "تاريخ الصفقة",
  price: "السعر",
  pricePlaceholder: "مثال: 500,000 ريال",
  progress: "نسبة التقدم",
  completed: "مكتمل",
  pending: "قيد الانتظار",
  inProgress: "قيد التنفيذ",
  in_progress: "قيد التنفيذ",
  sale: "بيع",
  rent: "إيجار",
  buy: "شراء",
  sell: "بيع",
  apartment: "شقة",
  villa: "فيلا",
  land: "أرض",
  commercial: "تجاري",
  office: "مكتب",
  other: "أخرى",
  selectPropertyType: "اختر...",
  selectInterestType: "اختر...",
  interests: "الاهتمامات والتفضيلات",
  budgetPlaceholder: "مثال: 500,000 - 800,000 ريال",
  dealNotesPlaceholder: "ملاحظات إضافية حول هذه الصفقة...",
  failedToSaveDeal: "فشل حفظ الصفقة. يرجى المحاولة مرة أخرى.",
  
  // Enhanced form fields
  useAsWhatsApp: "استخدام كواتساب",
  copyToWhatsApp: "نسخ إلى واتساب",
  quickInterest: "الاهتمام السريع:",
  addMoreDetails: "إضافة المزيد من التفاصيل",
  additionalContact: "معلومات الاتصال الإضافية",
  additionalInfo: "معلومات إضافية",
  saveAndAddAnother: "حفظ وإضافة آخر",
  budgetMinPlaceholder: "الحد الأدنى (مثال: 500000)",
  budgetMaxPlaceholder: "الحد الأقصى (مثال: 800000)",
  currency: "ريال",
  budgetHint: "أدخل الأرقام فقط. اترك الحد الأقصى فارغاً للميزانية الثابتة.",
  namePlaceholder: "الاسم الكامل",
  phonePlaceholder: "مثال: +966 5XX XXX XXXX",
  whatsappPlaceholder: "رقم واتساب مختلف (اختياري)",
  emailPlaceholder: "example@email.com",
  addressPlaceholder: "العنوان، المدينة",
  notesPlaceholder: "ملاحظات إضافية حول العميل...",
  
  // WhatsApp Conversations
  conversations: "المحادثات",
  searchConversations: "بحث المحادثات...",
  noConversations: "لا توجد محادثات",
  selectConversation: "اختر محادثة لعرض الرسائل",
  noMessages: "لا توجد رسائل",
  now: "الآن",
  minutesAgo: "دقيقة",
  hoursAgo: "ساعة",
  daysAgo: "يوم",
  
  // WhatsApp Insights
  whatsappInsights: "تحليلات واتساب",
  clientsWaiting: "عملاء في انتظار الرد",
  averageResponseTime: "متوسط وقت الرد",
  responseTimeDescription: "متوسط الوقت بين رسالة العميل الأولى ورد الوكيل",
  mostRequestedPropertyType: "أكثر نوع عقار مطلوب",
  mostMentionedArea: "أكثر منطقة مذكورة",
  minutes: "دقيقة",
  hours: "ساعة",
  noData: "لا توجد بيانات",
  
  // Property types
  residential: "سكني",
  studio: "استوديو",
  penthouse: "بنتهاوس",
  townhouse: "تاون هاوس",
  farmland: "أرض زراعية",
  warehouse: "مستودع",
};

export const en = {
  // Header
  subtitle: "Real Estate Real Results",
  
  // Navigation
  clients: "Clients",
  leads: "Leads",
  importContacts: "Import from Phone",
  account: "Account",
  
  // Clients
  addClient: "Add Client",
  searchClients: "Search for Clients",
  searchClientsPlaceholder: "Search by name, phone, email",
  noClients: "No clients found",
  noClientsDesc: "Start by adding your first client or importing contacts from your phone.",
  loadingClients: "Loading clients...",
  edit: "Edit",
  delete: "Delete",
  selectAll: "Select All",
  selected: "selected",
  deleteSelected: "Delete Selected",
  areYouSureDelete: "Are you sure you want to delete this client?",
  areYouSureDeleteMultiple: "Are you sure you want to delete",
  clientsText: "client(s)?",
  
  // Leads
  addLead: "Add Lead",
  searchLeads: "Search for Leads",
  searchLeadsPlaceholder: "Search by name, phone, email",
  noLeads: "No leads found",
  noLeadsDesc: "Start by adding your first lead or importing contacts from your phone.",
  loadingLeads: "Loading leads...",
  convertToClient: "Convert to Client",
  convertConfirm: "Convert this lead to a client?",
  allStatus: "All Status",
  new: "New",
  contacted: "Contacted",
  qualified: "Qualified",
  converted: "Converted",
  
  // Modals
  addNewClient: "Add New Client",
  editClient: "Edit Client",
  addNewLead: "Add New Lead",
  editLead: "Edit Lead",
  name: "Name",
  nameRequired: "Name is required",
  phone: "Phone",
  whatsapp: "WhatsApp",
  email: "Email",
  address: "Address",
  notes: "Notes",
  status: "Status",
  active: "Active",
  inactive: "Inactive",
  source: "Source",
  interestType: "Interest Type",
  propertyPreference: "Property Preference",
  budget: "Budget",
  cancel: "Cancel",
  save: "Save",
  saving: "Saving...",
  
  // Import
  importTitle: "Import Contacts",
  howToImport: "How to Import Your Contacts",
  fromiPhone: "From iPhone Contacts",
  fromAndroid: "From Android/Other Phones",
  supportedFormats: "Supported Formats",
  importAs: "Import as:",
  dropFile: "Drop your CSV file here or click to browse",
  supportedFormatsDesc: "Supported formats: CSV or vCard (.vcf) files",
  preview: "Preview (first 10 rows):",
  totalRows: "Total rows in file will be imported. Make sure the preview looks correct.",
  importButton: "Import",
  importing: "Importing...",
  importAsClients: "Import as Clients",
  importAsLeads: "Import as Leads",
  
  // Table view
  cards: "Cards",
  table: "Table",
  actions: "Actions",
  
  // Status
  newStatus: "New",
  contactedStatus: "Contacted",
  qualifiedStatus: "Qualified",
  
  // Interest types
  buying: "Buying",
  selling: "Selling",
  renting: "Renting",
  investing: "Investing",
  
  // Messages
  selectAtLeastOne: "Please select at least one client to delete",
  selectAtLeastOneLead: "Please select at least one lead to delete",
  failedToLoad: "Failed to load clients. Please try again.",
  failedToLoadLeads: "Failed to load leads. Please try again.",
  failedToDelete: "Failed to delete client. Please try again.",
  failedToDeleteLead: "Failed to delete lead. Please try again.",
  failedToSave: "Failed to save client. Please try again.",
  failedToSaveLead: "Failed to save lead. Please try again.",
  leadConverted: "Lead converted to client successfully!",
  successfullyDeleted: "Successfully deleted",
  successfullyImported: "Import Successful!",
  importCompletedWithErrors: "Import Completed with Errors",
  successfullyImportedCount: "Successfully imported",
  contacts: "contacts successfully",
  errors: "Errors",
  
  // Connection status
  serverConnectionError: "Server Connection Error",
  cannotConnect: "Cannot connect to the backend server. Please make sure the server is running.",
  toStartServer: "To start the server:",
  runCommand: "Open a terminal and run: cd server && npm run dev",
  
  // Language
  language: "Language",
  arabic: "Arabic",
  english: "English",

  // Account
  accountInfo: "Account Info",
  userId: "User ID",
  roleLabel: "Role",
  phoneLabel: "Phone",
  createdAt: "Created at",
  ownerId: "Owner ID",
  refresh: "Refresh",
  loadingAccount: "Loading account info...",
  noUser: "No account data",
  notAvailable: "Not available",
  failedToLoadAccount: "Failed to load account info. Please try again.",
  failedToSaveAccount: "Failed to save account info.",
  accountUpdated: "Account updated successfully",
  back: "Back",
  
  // Import alerts
  pleaseSelectFile: "Please select a file first",
  pleaseSelectCSV: "Please select a CSV or vCard (.vcf) file",
  noValidContactsVCF: "No valid contacts found in the vCard file. Make sure the file contains contact information.",
  failedToImport: "Failed to import contacts",
  errorReadingFile: "Error reading file",
  
  // Contact actions
  call: "Call",
  noPhoneNumber: "No phone number",
  noWhatsApp: "No WhatsApp",
  noEmail: "No email address",
  
  // Activities
  activityHistory: "Activity History",
  activities: "Activities",
  addActivity: "Add Activity",
  activityType: "Activity Type",
  noActivities: "No activities recorded",
  meeting: "Meeting",
  note: "Note",
  title: "Title",
  titlePlaceholder: "Activity title (optional)",
  description: "Description",
  descriptionPlaceholder: "Activity description...",
  loading: "Loading...",
  
  // Reminders
  reminders: "Reminders",
  upcomingReminders: "Upcoming Reminders",
  addReminder: "Add Reminder",
  reminderTitle: "Reminder Title",
  reminderTitlePlaceholder: "e.g., Follow up with client",
  reminderDate: "Reminder Date",
  noReminders: "No reminders",
  deleteReminderConfirm: "Are you sure you want to delete this reminder?",
  
  // Quick Actions
  quickActions: "Quick Actions",
  viewClient: "View Client",
  viewActivities: "View Activities",
  viewReminders: "View Reminders",
  
  // Dashboard
  dashboard: "Dashboard",
  totalClients: "Total Clients",
  totalLeads: "Total Leads",
  recentActivities: "Recent Activities (7 days)",
  leadsByStatus: "Leads by Status",
  clickForDetails: "Click for details",
  activitiesInfo: "To view activities, click on individual contacts in the Clients or Leads sections.",
  summary: "Summary",
  recentActivitiesSummary: "Showing the last {count} activities across all contacts.",
  unknownContact: "Unknown Contact",
  
  // Export
  export: "Export",
  exportClients: "Export Clients",
  exportLeads: "Export Leads",
  
  // Favorites
  favorites: "Favorites",
  showFavorites: "Show Favorites",
  showAll: "Show All",
  addToFavorites: "Add to Favorites",
  removeFromFavorites: "Remove from Favorites",
  
  // Deals
  deals: "Deals",
  viewDeals: "View Deals",
  addDeal: "New Deal",
  editDeal: "Edit Deal",
  closedDeals: "Closed Deals & Transactions",
  noDeals: "No deals found",
  noDealsDesc: "Click \"Add Deal\" to create your first deal",
  deleteDealConfirm: "Are you sure you want to delete this deal?",
  allDealTypes: "All Types",
  allPropertyTypes: "All Properties",
  contactType: "Contact Type",
  selectContact: "Select Contact",
  dealDetails: "Deal Details",
  failedToLoadDeals: "Failed to load deals",
  propertyType: "Property Type",
  propertyAddress: "Property Address",
  propertyAddressPlaceholder: "Enter property address",
  dealType: "Deal Type",
  dealDate: "Deal Date",
  price: "Price",
  pricePlaceholder: "e.g., 500,000 SAR",
  progress: "Progress",
  completed: "Completed",
  pending: "Pending",
  inProgress: "In Progress",
  in_progress: "In Progress",
  sale: "Sale",
  rent: "Rent",
  buy: "Buy",
  sell: "Sell",
  apartment: "Apartment",
  villa: "Villa",
  land: "Land",
  commercial: "Commercial",
  office: "Office",
  other: "Other",
  selectPropertyType: "Select...",
  selectInterestType: "Select...",
  interests: "Interests & Preferences",
  budgetPlaceholder: "e.g., 500,000 - 800,000 SAR",
  dealNotesPlaceholder: "Additional notes about this deal...",
  failedToSaveDeal: "Failed to save deal. Please try again.",
  
  // Enhanced form fields
  useAsWhatsApp: "Use as WhatsApp",
  copyToWhatsApp: "Copy to WhatsApp",
  quickInterest: "Quick Interest:",
  addMoreDetails: "Add More Details",
  additionalContact: "Additional Contact",
  additionalInfo: "Additional Information",
  saveAndAddAnother: "Save & Add Another",
  budgetMinPlaceholder: "Min (e.g., 500000)",
  budgetMaxPlaceholder: "Max (e.g., 800000)",
  currency: "SAR",
  budgetHint: "Enter numbers only. Leave max empty for fixed budget.",
  namePlaceholder: "Full name",
  phonePlaceholder: "e.g., +966 5XX XXX XXXX",
  whatsappPlaceholder: "Different WhatsApp number (optional)",
  emailPlaceholder: "email@example.com",
  addressPlaceholder: "Street address, City",
  notesPlaceholder: "Additional notes about the client...",
  
  // WhatsApp Conversations
  conversations: "Conversations",
  searchConversations: "Search conversations...",
  noConversations: "No conversations",
  selectConversation: "Select a conversation to view messages",
  noMessages: "No messages",
  now: "Now",
  minutesAgo: "minutes ago",
  hoursAgo: "hours ago",
  daysAgo: "days ago",
  
  // WhatsApp Insights
  whatsappInsights: "WhatsApp Insights",
  clientsWaiting: "Clients Waiting for Reply",
  averageResponseTime: "Average Response Time",
  responseTimeDescription: "Average time between first client message and agent reply",
  mostRequestedPropertyType: "Most Requested Property Type",
  mostMentionedArea: "Most Mentioned Area",
  minutes: "minutes",
  hours: "hours",
  noData: "No data",
  
  // Property types
  studio: "Studio",
  penthouse: "Penthouse",
  townhouse: "Townhouse",
  warehouse: "Warehouse",
};
